import React from "react";
import ReactDOM from "react-dom/client";
import * as Sentry from "@sentry/react";
import { ErrorBoundary } from "react-error-boundary";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import "./index.css";

import "react-loading-skeleton/dist/skeleton.css";
import App from "./App";
import { Fallback } from "./ErrorBoundaryFallback";
import { store } from "./redux/store";
import reportWebVitals from "./reportWebVitals";
import "./styles/styles.scss";

const isDevelopment = process.env.NODE_ENV === 'development';

Sentry.init({
	dsn: "https://f6bfc914a28d4100ba5f8a7167a8b5af@o4509367072456704.ingest.us.sentry.io/4510720372768768",
	environment: process.env.NODE_ENV,
	enabled: !isDevelopment,
	integrations: [
		Sentry.browserTracingIntegration(),
		Sentry.replayIntegration({
			maskAllText: false,
			blockAllMedia: false,
		}),
	],
	tracesSampleRate: 0.1,
	replaysSessionSampleRate: 0.1,
	replaysOnErrorSampleRate: 1.0,
	sendDefaultPii: true,
	beforeSend(event) {
		// Filter out local development errors
		if (isDevelopment) {
			return null;
		}
		return event;
	},
});

const root = ReactDOM.createRoot(
	document.getElementById("root") as HTMLElement
);
root.render(
	<Provider store={store}>
		<BrowserRouter
			future={{
				// eslint-disable-next-line @typescript-eslint/naming-convention
				v7_startTransition: true,
				// eslint-disable-next-line @typescript-eslint/naming-convention
				v7_relativeSplatPath: true,
			}}
		>
			<ErrorBoundary FallbackComponent={Fallback}>
				<App />
			</ErrorBoundary>
		</BrowserRouter>
	</Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
